import { AwAppContext } from "./AwAppContext";

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import { Provider as ReduxProvider } from "react-redux";

import "primereact/resources/themes/lara-light-indigo/theme.css"; 
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "@progress/kendo-theme-default/dist/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "semantic-ui-css/semantic.min.css";


import "./index.css";
import * as serviceWorker from "./serviceWorker";

// Create browser history to use in the Redux store
// const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");

// Get the application-wide store instance, prepopulating with state from the server where available.
// const initialState = window.initialReduxState;

import { store, runSagaMiddlware } from "./store/configureStore";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// runSagaMiddlware();

// ReactDOM.render(
//   <ReduxProvider store={store}>
//     <AwAppContext />
//   </ReduxProvider>,
//   // <div>it works</div>,
//   document.getElementById("root")
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();


//-----------------
const rootElement = document.getElementById('root');

const root = createRoot(rootElement as Element);

runSagaMiddlware();

root.render(
    <ReduxProvider store={store}>
      <AwAppContext />
    </ReduxProvider>
  );
//-----------------
  // const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
// const rootElement = document.getElementById('root');
// const root = createRoot(rootElement as any);

// root.render(
//   <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
//         <h1>It works</h1>
//     </div>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();